import { Turnstile } from "@/components/turnstile"
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

export interface VisibleTurnstileDialogProps {
  open: boolean
  onVerify: (cfToken: string) => void
  onError: (errorCode: string) => void
  onUnsupported?: () => void
  onScriptLoadError?: () => void
}

export function VisibleTurnstileDialog({
  open,
  onVerify,
  onError,
  onUnsupported,
  onScriptLoadError,
}: VisibleTurnstileDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Additional Verification</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p className="mx-auto">
            Help us keep our platform safe. Please complete the verification to
            proceed.
          </p>
          <div className="my-4 flex justify-center">
            <Turnstile
              id="visible-dialog-turnstile"
              onSuccess={onVerify}
              onError={onError}
              onUnsupported={onUnsupported}
              onScriptLoadError={onScriptLoadError}
            />
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
